import React, { useState, useEffect } from 'react';
import { Card, Dropdown, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CardDropdown from 'components/common/CardDropdown';
import SoftBadge from 'components/common/SoftBadge';
import { Link } from 'react-router-dom';
import ContentTableHeader from './ContentTableHeader';
import ContentHeader from './ContentHeader';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import {
  getContents,
  deleteContents,
  toggleActivationContents
} from '../../../lib/apiService';
import card from 'assets/img/gegee/card.png';

const ContentList = () => {
  const [getSerivceDatas, setGetServiceDatas] = useState([]);
  const [pageIndex, setPageIndex] = useState({
    total: 0,
    currentIndex: 0,
    pageCount: 1,
    start: 0,
    end: 0,
    limit: 20,
    prevPage: 0
  });

  const fetchData = async (queryString = {}) => {
    try {
      const response = await getContents(queryString);

      if (response?.data?.pagination) {
        const { total, prevPage, pageCount, start, end, limit } =
          response.data.pagination;

        setPageIndex(prev => ({
          ...prev,
          total,
          pageCount,
          start,
          end,
          limit,
          prevPage
        }));

        setGetServiceDatas(response?.data?.data);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    fetchData(`?limit=${pageIndex.limit}&page=${pageIndex.currentIndex + 1}`);
  }, [pageIndex.currentIndex]); // Re-fetch data when pageIndex.pageCount changes

  const handleNextPage = () => {
    if (pageIndex.currentIndex < Math.ceil(pageIndex.total / pageIndex.limit)) {
      setPageIndex(prev => ({ ...prev, currentIndex: prev.currentIndex + 1 }));
    }
  };

  const handlePreviousPage = () => {
    if (pageIndex.currentIndex + 1 > 1) {
      setPageIndex(prev => ({ ...prev, currentIndex: prev.currentIndex - 1 }));
    }
  };

  const handleGoToPage = page => {
    setPageIndex(prev => ({ ...prev, currentIndex: page }));
  };

  const handleFieldChange = (value, serviceId) => {
    if (value === 'delete') {
      deleteContents([serviceId])
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай устгагдлаа`, {
              theme: 'colored'
            });
            fetchData();
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
    } else {
      toggleActivationContents([serviceId], value === 'active' ? true : false)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай шинэчилэгдлээ`, {
              theme: 'colored'
            });
            fetchData();
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
    }
  };

  const columns = [
    {
      accessor: 'name',
      Header: 'Дугаар',
      headerProps: { className: 'pe-5' },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { _id } = rowData.row.original;
        return (
          <>
            <Link to={`/content/content-update/${_id}`}>
              <strong>#{_id.slice(-6)}</strong>
            </Link>
          </>
        );
      }
    },
    {
      accessor: 'image',
      Header: 'Зураг',
      headerProps: { className: 'pe-1' },
      cellProps: {
        className: 'py-1'
      },
      Cell: rowData => {
        const { image, title, _id } = rowData.row.original;
        return (
          <>
            {image && image.url ? (
              <Link to={`/info/info-update/${_id}`}>
                <img
                  className="rounded-1 border border-200"
                  src={image?.url}
                  onError={e => {
                    e.target.onerror = null; // Prevent infinite loop
                    e.target.src = ''; // Replace broken image with placeholder
                  }}
                  width={40}
                  alt={title}
                />
              </Link>
            ) : (
              <img
                className="rounded-1 border border-200"
                src={card}
                width={40}
                alt={'no image'}
              />
            )}
          </>
        );
      }
    },
    {
      accessor: 'file',
      Header: 'Файл',
      Cell: rowData => {
        const { file } = rowData.row.original;
        return (
          <Link target="__blank" to={file.url}>
            {file.url.substring(0, 40)}
          </Link>
        );
      }
    },
    {
      accessor: 'date',
      Header: 'Огноо',
      headerProps: { className: 'pe-2' },
      Cell: rowData => {
        const { createdAt } = rowData.row.original;
        return <>{createdAt.split('T')[0]}</>;
      }
    },
    {
      accessor: 'contentType',
      Header: 'Төрөл',
      Cell: rowData => {
        const { contentType } = rowData.row.original;
        return (
          <SoftBadge pill bg="info" className="me-2">
            {contentType}
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'address',
      Header: 'Гарчиг',
      Cell: rowData => {
        const { title } = rowData.row.original;
        return <>{title.substring(0, 40)}</>;
      }
    },
    {
      accessor: 'status',
      Header: 'Төлөв',
      headerProps: { className: 'pe-7' },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return status ? (
          <SoftBadge pill bg="success" className="me-2">
            Нээлттэй
          </SoftBadge>
        ) : (
          <SoftBadge pill bg="secondary" className="me-2">
            Хаалттай
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'user',
      Header: 'Нийтэлсэн',
      Cell: rowData => {
        const { creator } = rowData.row.original;
        return <>{creator?.email}</>;
      }
    },

    {
      accessor: 'none',
      Header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      Cell: rowData => {
        const { _id: infoId } = rowData.row.original;
        return (
          <CardDropdown>
            <div className="py-2">
              <Dropdown.Item
                onClick={() => handleFieldChange('active', infoId)}
              >
                Нээх
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleFieldChange('close', infoId)}>
                Хаах
              </Dropdown.Item>
              <Dropdown.Divider as="div" />
              <Dropdown.Item
                onClick={() => handleFieldChange('delete', infoId)}
                className="text-danger"
              >
                Устгах
              </Dropdown.Item>
            </div>
          </CardDropdown>
        );
      }
    }
  ];

  return (
    <>
      <Col xs={12} className="mb-3">
        <ContentHeader />
      </Col>

      <AdvanceTableWrapper
        columns={columns}
        data={getSerivceDatas}
        selection
        sortable
        pagination
        perPage={pageIndex.limit}
      >
        <Card className="mb-3">
          <Card.Header>
            <ContentTableHeader
              table
              getSerivceDatas={getSerivceDatas}
              refetch={fetchData}
            />
          </Card.Header>
          <Card.Body className="p-0">
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs--1 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer>
            {getSerivceDatas && getSerivceDatas.length > 0 && (
              <AdvanceTablePagination
                canPreviousPage={pageIndex.currentIndex !== 0}
                canNextPage={
                  !(pageIndex.currentIndex + 1 === pageIndex.pageCount)
                }
                previousPage={handlePreviousPage}
                nextPage={handleNextPage}
                pageCount={Math.ceil(pageIndex.total / pageIndex.limit)}
                pageIndex={pageIndex.currentIndex}
                gotoPage={handleGoToPage}
              />
            )}
          </Card.Footer>
        </Card>
      </AdvanceTableWrapper>
    </>
  );
};

export default ContentList;
